module.exports = __webpack_public_path__ + "static/media/sprocket-web-white.86608044.svg";